'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var $ = require("jquery");
var Modal = /** @class */ (function () {
    function Modal() {
        $('.trigModalOn').on('click', function () {
            var path = $(this).data('path');
            $('#bulletModalImg').attr('src', path);
            $('#bulletModal').addClass('show');
        });
        $('.trigModalOnMovie').on('click', function () {
            var iframe = '#bulletModalIFrame';
            var currentMovie = $(iframe).attr('src');
            if (currentMovie == '') {
                var key = $(this).data('key');
                $(iframe).attr('src', 'https://www.youtube.com/embed/' + key);
            }
            $('#bulletModalMovie').addClass('show');
        });
        $('#trigChangeObjectFit').on('click', function (e) {
            var posX = Math.ceil(e.clientX / $(window).width() * 21);
            var posY = Math.ceil(e.clientY / $(window).height() * 21);
            console.log(posX, posY);
            var fit = $(this).attr('data-fit');
            var newFit = (fit == 'cover') ? 'contain' : 'cover';
            $(this).attr('data-fit', newFit);
            $(this).children('img').attr('data-x', posX).attr('data-y', posY);
        });
        $('.trigCloseModal').on('click', function (e) {
            $('#bulletModal').removeClass('show');
        });
        $('.trigCloseModalMovie').on('click', function (e) {
            $('#bulletModalMovie').removeClass('show');
        });
    }
    return Modal;
}());
exports.Modal = Modal;
exports.default = Modal;
